module.exports = __webpack_public_path__ + "static/media/HomeLogo.af48bd64.svg";